import React, { useState, useEffect }       from 'react';
import { useNavigate }                      from 'react-router-dom';
import { useTranslation }                   from 'react-i18next';
import axios                                from 'axios';
import ForumIcon                            from '@mui/icons-material/Forum';import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableRow, 
    Typography, 
    Paper, 
    Box, 
    Divider,
    Skeleton
} from '@mui/material';
import ApiService from './service/ApiService';

const AvvisiTable = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [datiMessaggi,    setDatiMessaggi ] = useState([]);
    const [loading,         setLoading      ] = useState(true);    

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const idSAT = user?.id;

    const headers = {
        Authorization: `Bearer ${token}`,
    };

    const fetchDatiRMA = async () => {
        setLoading(true); 
        try {
            const tipoMessaggio = 1; // 1 per messaggi, 0 per avvisi
            // const responseMessaggi = await axios.get(`http://localhost:8080/messaggio/elenco?id=${idSAT}&tipo=${tipoMessaggio}`, { headers: headers });
            const responseMessaggi = await ApiService.request("elencoMessaggi", { id: idSAT, tipo: 1});

            if (responseMessaggi.data) {
                const messaggi = responseMessaggi.data.messaggi;
                
                const groupedMessages = {};
                messaggi.forEach((msg) => {
                    const { idReso, testi } = msg;
                    if (!groupedMessages[idReso] || (testi && testi.length > 0)) {
                        groupedMessages[idReso] = {
                            ...msg,
                            lastMessage: testi[testi.length - 1].descrizione,
                            lastMessageDate: new Date(testi[testi.length - 1].data),
                        };
                    }
                });
                const sortedMessages = Object.values(groupedMessages).sort((a, b) => b.lastMessageDate - a.lastMessageDate);

                setDatiMessaggi(sortedMessages);
            } else {
                console.error("I dati ottenuti non sono nel formato Array:", responseMessaggi.data);
            }
        } catch (error) {
            console.error("Errore nel recupero dei dati RMA", error);
        } finally {
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchDatiRMA();
    }, []);

    const handleNavigate = (messaggio) => {        
        navigate('/chat', { 
            state: { 
                contact: {
                    idCliente:          messaggio?.idCliente,
                    idReso:             messaggio.idReso,
                    ragioneSociale:     messaggio.ragioneSocialeCliente,
                    email:              messaggio.email, 
                    ultimoMessaggio:    messaggio.lastMessage,
                    id:                 messaggio.id 
                },
                allMessages: datiMessaggi,
                isNavigatingFromAvvisi: true
            }
        });
    };
    

    // Funzione per troncare il messaggio se troppo lungo
    const truncateMessage = (message, maxLength = 35) => {
        return message.length > maxLength ? message.slice(0, maxLength) + '...' : message;
    };

    return (
        <>
            <TableContainer component={Paper}
                sx={{
                    borderRadius: '30px',
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                    mr: 1,
                    ml: 1,
                    mt: { xs: 2, md: 0 },
                    width: 'auto',
                    height: '58vh',
                    overflowY: 'auto',
                    background: 'linear-gradient(145deg, #fefefe, #f5f5f5)',
                    border: '1px solid #cccccc',
                    '&::-webkit-scrollbar': {
                        display: 'none', // Chrome, Safari, Opera
                    },
                    'msOverflowStyle:': 'none',  // IE e Edge
                    'scrollbarWidth': 'none',  // Firefox
                }}>
                <Box sx={{ 
                    display: 'flex',
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    p: 2,
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    background: 'linear-gradient(145deg, #fefefe, #f5f5f5)',
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 2 }}>
                        <ForumIcon sx={{ width: '32px', height: '32px', color: '#FDA03D'}} />
                        <Typography variant="h5" fontWeight="bold" textAlign="center" color="#FDA03D">
                            {t('Messaggi')}
                        </Typography>
                    </Box>
                </Box>
                <Divider sx={{ width: '100%', border: 'solid 0.5px #E0E0E0' }} />
                <Table aria-label="Avvisi Table">
                    <TableBody>
                        {loading ? (
                            Array.from(new Array(5)).map((_, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <Skeleton variant="text" width="80%" height={30} />
                                        <Skeleton variant="text" width="60%" height={20} />
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            datiMessaggi.length === 0 ? (
                                <TableRow>
                                    <TableCell>
                                        <Typography variant="body1" color="textSecondary" align="center">
                                        {t('Non hai ancora messaggi')}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                datiMessaggi.map((messaggio) => (
                                    <TableRow key={messaggio.id} onClick={() => handleNavigate(messaggio)}
                                        sx={{
                                            '&:hover': {
                                                backgroundColor: '#f5f5f5',
                                                cursor: 'pointer', 
                                                transform: 'scale(1.003)', 
                                                transition: 'transform 0.2s ease-in-out',
                                            }
                                        }}>
                                        <TableCell>
                                            <Typography variant="subtitle1" fontWeight="bold" color='#263F78'>
                                                {messaggio.ragioneSocialeCliente || t('Cliente')} - #{messaggio.idReso}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {truncateMessage(messaggio.lastMessage)}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default AvvisiTable;
